import fieldForm from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('judging/scoring-criteria/:any', fieldForm);
Router.get('judging/scoring-criteria', index);
